import {safeOptional} from '../../safe-optional'
import * as z from 'zod'

export const AssetSchema = z.lazy(() =>
  z.object({
    fields: z.object({
      description: z.string().optional(),

      file: z.object({
        url: z.string(),
        details: safeOptional(
          z.object({
            image: safeOptional(
              z.object({
                width: z.number(),
                height: z.number(),
              }),
            ),
          }),
        ),
      }),
    }),
  }),
)

export type Asset = z.infer<typeof AssetSchema>
